export const isEmptyFilter = (filterObj: Record<string, any>) => {
  for (const key in filterObj) {
    if (filterObj.hasOwnProperty(key)) {
      const value = filterObj[key];
      if (value === null || value === undefined) continue;
      if (typeof value === 'object') {
        if (!isEmptyFilter(value)) return false;
      } else return false;
    }
  }
  return true;
};
